import Fap from '@/modules-v2/fap/views/index';

const order = [
  {
    path: '/fap',
    name: 'Fap',
    component: Fap,
    meta: {
      title: 'Fap',
      requiresAuth: true,
    },
  },
];

export default order;
